import { render } from "./Affix.vue?vue&type=template&id=469da624"
import script from "./Affix.vue?vue&type=script&lang=js"
export * from "./Affix.vue?vue&type=script&lang=js"
script.render = render

export default script